import {
  trigger,
  state,
  style,
  animate,
  transition,
  keyframes
} from '@angular/animations';

export const slideInRightAnimation =
    trigger('slideInRight', [
        // Enter transition
      transition(':enter', [
          // styles at start of transition
        style({ opacity: 0 }),
        // animation and styles at end of transition
        animate('1s 0.7s', keyframes([
          style({ opacity: 0, transform: 'translate3d(100%, 0, 0)' }),
          style({ opacity: 1, transform: 'translate3d(0, 0, 0)' })
        ]))
      ])
    ]);



// WEBPACK FOOTER //
// ./src/app/shared/animations/slideInRight.animation.ts